module.exports = __webpack_public_path__ + "media/images/flags/32/Israel-6dbeed06e48ae0ab0e7b84f49d74cfc6.png";